import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i2134451975__a)" }, [
      _createElementVNode("path", {
        fill: "#242424",
        "fill-rule": "evenodd",
        d: "M15.99 10.631c-.179-1.128-1.215-1.834-1.683-2.102 0 0-.604-1.347-.879-1.97a1.708 1.708 0 0 0-.83-3.199H8.878v1.051h3.594a.6.6 0 1 1 0 1.2h-2.036l.976 2.461c.038.35-.04.708-.222 1.011l-.164.271H9.833l-.85-2.338a.62.62 0 0 0-.588-.411H5.5V3a.626.626 0 0 0-.625-.625H.625A.626.626 0 0 0 0 3v4.225c0 .345.28.625.625.625h1.596l-1.047 2.618a.83.83 0 0 0-.035.548c.108.36.43.541.781.541h.597v.173a2.38 2.38 0 0 0 2.375 2.375 2.38 2.38 0 0 0 2.298-1.777c.237.178.527.277.827.277h2.565q.173-.002.335-.043a2.38 2.38 0 0 0 2.225 1.543 2.38 2.38 0 0 0 2.376-2.375.6.6 0 0 0-.024-.173c.242-.095.471-.28.497-.612a1.4 1.4 0 0 0 0-.312zM3.673 11.774c0 .67.548 1.216 1.22 1.216h.001c.67 0 1.217-.545 1.217-1.216v-.216H3.672zm9.473 1.216a1.224 1.224 0 0 1-1.222-1.207v-.226h2.449v.217c0 .671-.556 1.216-1.227 1.216",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i2134451975__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }